import React from 'react';
import Icon from 'framework-ui-components/Components/Icons/Icon';

export default Icon(
  <g>
    <path d="M15.6,7.5L7.4,9.1v11l8.1,1.6V7.5z M16.1,9.1v1.6h1.6v1.1h-1.6v1.1h1.6V14h-1.6v1.1h1.6v1.1h-1.6v1.1h1.6v1.1h-1.6V20h5c0.3,0,0.5-0.2,0.5-0.5V9.6c0-0.3-0.2-0.5-0.5-0.5H16.1z M18.3,10.8h2.2v1.1h-2.2V10.8z M9.1,11.8h1.5l0.8,1.7c0.1,0.1,0.1,0.3,0.2,0.5c0-0.1,0.1-0.3,0.2-0.5l0.9-1.6H14l-1.6,2.7l1.7,2.8h-1.5l-0.9-1.8c0-0.1-0.1-0.2-0.1-0.4h0c0,0.1-0.1,0.2-0.1,0.4l-0.9,1.8H9l1.7-2.7L9.1,11.8z M18.3,12.9h2.2V14h-2.2V12.9z M18.3,15.1h2.2v1.1h-2.2V15.1z M18.3,17.3h2.2v1.1h-2.2V17.3z" />
  </g>,
  '0 0 29 29'
);
